import { Task, TaskArea } from './task';

export type ServiceOrderStatus = 'agendado' | 'em_andamento' | 'encerrado' | 'inativo';

export interface ServiceOrder {
  _id: string;
  name: string;
  description?: string;
  startDate: string;
  endDate: string;
  billingMonth: number;
  billingYear: number;
  projectId: string;
  userId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  status?: ServiceOrderStatus;
  durationDays?: number;
  dateRange?: string;
  billingPeriodLabel?: string;
}

export interface ServiceOrderWithTasks extends ServiceOrder {
  tasks: Task[];
  tasksByArea: {
    [key in TaskArea]?: {
      tasks: Task[];
      totalHoras: number;
      count: number;
    };
  };
  totalTasks: number;
  totalHoras: number;
}

export interface CreateServiceOrderRequest {
  name: string;
  description?: string;
  startDate: string;
  endDate: string;
  billingMonth?: number;
  billingYear?: number;
}

export interface UpdateServiceOrderRequest {
  name?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  billingMonth?: number;
  billingYear?: number;
  isActive?: boolean;
}

export interface ServiceOrderListResponse {
  success: boolean;
  data: {
    serviceOrders: ServiceOrderWithTasks[];
    unassignedTasks: Task[];
    count: number;
  };
}

export interface ServiceOrderResponse {
  success: boolean;
  message?: string;
  data: {
    serviceOrder: ServiceOrderWithTasks;
  };
}

export interface ServiceOrderError {
  success: false;
  message: string;
  errors?: any[];
}

export interface AssignTaskRequest {
  taskId: string;
}

export interface TaskAssignmentResponse {
  success: boolean;
  message: string;
  data: {
    task: Task;
  };
}

// Helper types for drag and drop
export interface DragItem {
  id: string;
  type: 'task';
  task: Task;
}

export interface DropZone {
  id: string;
  type: 'service-order' | 'unassigned';
  serviceOrderId?: string;
}

// Socket.io event types
export interface SocketEvents {
  'service-order:created': (data: { serviceOrder: ServiceOrder; projectId: string }) => void;
  'service-order:updated': (data: { serviceOrder: ServiceOrder; projectId: string }) => void;
  'service-order:deleted': (data: { serviceOrderId: string; projectId: string }) => void;
  'task:assigned': (data: { task: Task; serviceOrderId: string; projectId: string }) => void;
  'task:unassigned': (data: { task: Task; projectId: string }) => void;
  'hours:updated': (data: { serviceOrderId: string; tasksByArea: ServiceOrderWithTasks['tasksByArea']; totalHoras: number; projectId: string }) => void;
}

// Status colors for UI
export const ServiceOrderStatusColors: Record<ServiceOrderStatus, string> = {
  'agendado': 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  'em_andamento': 'bg-green-500/20 text-green-300 border-green-500/30',
  'encerrado': 'bg-gray-500/20 text-gray-300 border-gray-500/30',
  'inativo': 'bg-red-500/20 text-red-300 border-red-500/30'
};

// Status labels in Portuguese
export const ServiceOrderStatusLabels: Record<ServiceOrderStatus, string> = {
  'agendado': 'Agendado',
  'em_andamento': 'Em Andamento',
  'encerrado': 'Encerrado',
  'inativo': 'Inativo'
};